import { render, staticRenderFns } from "./BoardContainer.vue?vue&type=template&id=354b54fc"
import script from "./BoardContainer.vue?vue&type=script&lang=js"
export * from "./BoardContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports